import Link from "next/link";
import { useRouter } from "next/navigation";
import { useAppDispatch } from "lib/redux/hooks";
import { setImportComponentOpen } from "lib/redux/settingsSlice";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import { StarIcon } from "@heroicons/react/24/solid";
import FacebookIllustration from "public/assets/heroIllustrations/facebookIllustration.svg";
import AmazonIllustration from "public/assets/heroIllustrations/amazonIllustration.svg";
import AirBnbIllustration from "public/assets/heroIllustrations/airbnbIllustration.svg";
import GoogleIllustration from "public/assets/heroIllustrations/googleIllustration.svg";
// import NetflixIllustration from "public/assets/heroIllustrations/netflixIllustration.svg";
import MobileNetflixIllustration from "public/assets/heroIllustrations/mobileNetflixIllustration.svg";
import MobileResumeIllustration from "public/assets/heroIllustrations/MobileResumeIllustration.svg";
// import GradientIllustration from "public/assets/heroIllustrations/gradientIllustration.svg";
import NewCircles from "public/assets/heroIllustrations/newCircles.svg";
import HeroBgPattern from "public/assets/heroIllustrations/heroBgPattern.svg";
import FreeText from "public/assets/heroIllustrations/freeText.svg";
// import AutofillBlackIcon from "public/assets/AutofillBlackIcon.svg";
import { cx } from "lib/cx";
import Image from "next/image";
import usersImage from "public/assets/heroIllustrations/usersImage.webp";
import atsImage from "public/assets/heroIllustrations/atsImage.webp";
import testimonialImage from "public/assets/heroIllustrations/testimonialImage.webp";
import GetResumeScoreIcon from "public/icons/getResumeScore.svg"

export const HeroMobile = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const handleResumeImport = () => {
    dispatch(setImportComponentOpen(true));
    router.push("/resume-builder");
  };
  const handleCheckScore = () =>{
   
    router.push("/upload-resume");
  }
  return (
    <section className="relative bg-[#F9F9F9] px-8 font-montserrat lg:hidden">
      <h1 className="mx-auto w-fit pt-5 text-center text-[18px] font-medium leading-5 tracking-tight md:text-[21px] md:leading-7">
        <span className="text-reveal line-1">
          <span className="text-[#52A1FF]">Enhance</span> Your Existing Resume
        </span>
        <br />
        <span className="text-reveal line-2">
          Or <span className="text-[#52A1FF]">Generate</span> New Resume
        </span>
        <br />
        <span className="text-reveal line-3 flex items-center">
          For{" "}
          <FreeText className="inline-block h-[27px] w-[38px] lg:h-[36px] lg:w-[51px] xl:h-[45px] xl:w-[64px] 2xl:h-[53px] 2xl:w-[76px]" />
        </span>
      </h1>

      <div className="min-h-[230px] md:min-h-[450px]">
        {/* <GradientIllustration className="absolute bottom-0 right-0" /> */}
        <HeroBgPattern className="absolute" />

        <div className="absolute left-1/2 top-[100px] -translate-x-1/2">
          <NewCircles className="rotating-circle mx-auto h-auto w-[260px] md:w-[500px]" />
        </div>

        <div className="absolute left-1/2 top-28 -translate-x-1/2 ">
          <MobileResumeIllustration
            className={cx(
              "fade-in-top-hero",
              "mx-auto h-[240px] w-[180px] md:h-[460px] md:w-[350px]"
            )}
          />
        </div>

        <div className="absolute left-3 top-36 md:left-40 md:top-40">
          <div
            className={cx(
              "fade-in-diagonal-left",
              "h-[60px] w-[210px] md:h-[107px] md:w-[320px]"
            )}
          >
            <Image
              src={usersImage}
              alt="heroImg"
              fill={true}
              priority
              fetchPriority="high"
              sizes="(min-width:768px) 40vw, 60vw"
            />
          </div>
        </div>

        <div className="absolute right-14 top-52 md:right-32 md:top-64">
          <div
            className={cx(
              "fade-in-diagonal-right",
              "h-[120px] w-[100px] md:h-[254px] md:w-[200px]"
            )}
          >
            <Image src={atsImage} alt="heroImg" fill={true} />
          </div>
        </div>

        <div className="absolute left-0 top-40 md:left-16 md:top-56">
          <div
            className={cx(
              "fade-in-diagonal-left",
              "h-[200px] w-[230px] md:h-[270px] md:w-[340px]"
            )}
          >
            <Image src={testimonialImage} alt="heroImg" fill={true} />
          </div>
        </div>
      </div>

      <div>
        <div className="mx-auto mt-10 flex w-fit items-center">
          <FacebookIllustration
            className={cx(
              "fade-in-left-hero del-1",
              "h-auto w-[40px] md:w-[57px]"
            )}
          />
          <AmazonIllustration
            className={cx(
              "fade-in-left-hero del-2 -ml-5",
              "h-auto w-[40px] md:w-[57px]"
            )}
          />
          <AirBnbIllustration
            className={cx(
              "fade-in-left-hero del-3 -ml-3",
              "h-auto w-[40px] md:w-[57px]"
            )}
          />
          <GoogleIllustration
            className={cx(
              "fade-in-left-hero del-4 -ml-4",
              "h-auto w-[40px] md:w-[57px]"
            )}
          />
          <MobileNetflixIllustration
            className={cx(
              "fade-in-left-hero del-5 -ml-4",
              "h-auto w-[40px] md:w-[57px]"
            )}
          />
        </div>
        <div className="fade-in-navbar mx-auto mt-5 w-fit text-[#3C3C3C]">
          <div className="mx-auto flex items-center gap-1">
            <StarIcon className="h-4 w-4 text-[#FFC700]" />
            <StarIcon className="h-4 w-4 text-[#FFC700]" />
            <StarIcon className="h-4 w-4 text-[#FFC700]" />
            <StarIcon className="h-4 w-4 text-[#FFC700]" />
            <StarIcon className="h-4 w-4 text-gray-300" />
            <div className="text-[12px] font-medium md:text-xs">4.5</div>
          </div>
          <div className="text-center text-[10px] md:text-xs">
            Rated by FAANG employees
          </div>
        </div>
        <div className="fade-in-navbar mx-auto mt-5 flex w-full justify-center gap-2 text-[10px] md:gap-7 md:text-xs">
          <Link href="/resume-builder">
            <button className="btn-gradient rounded-[40px] px-2 py-2 font-poppins min-[321px]:px-5 md:px-8">
              Generate Now <ArrowLongRightIcon className="h-auto w-4 md:w-6" />
            </button>
          </Link>
          <button
            className="flex items-center gap-2 rounded-[40px] px-2 py-2 font-poppins shadow-lg min-[321px]:px-5 md:px-8"
            onClick={handleCheckScore}
          >
            Get Resume Score <GetResumeScoreIcon className="h-6 w-6" />
          </button>
        </div>
      </div>
    </section>
  );
};
